import React, { useState, useEffect } from 'react'
import { useCreateSalesOrder } from '../../hooks/useSalesOrder';

const SalesOrderPopup = ({ isOpen, onClose, title, items = [], onReorder, children }) => {
  const [quantities, setQuantities] = useState([])
  const { createSalesOrder, loading: creating, error: createError } = useCreateSalesOrder();

  useEffect(() => {
    if (items && items.length > 0) {
      setQuantities(items.map(item => item.qty || item.quantity || 1 ))
    }
  }, [items])

  if (!isOpen) return null

  const handleQtyChange = (idx, value) => {
    const newQuantities = [...quantities]
    newQuantities[idx] = Number(value)
    setQuantities(newQuantities)
  }

  const handleReorder = async () => {
    const itemsWithId = items.map(item => ({
      ...item,
      item_id: '256873000149972193'
    }));
    await createSalesOrder(itemsWithId);
    if (onReorder) onReorder(quantities);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex justify-center items-center p-3 sm:p-4">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] flex flex-col p-4 sm:p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 sm:top-3 sm:right-3 z-10 h-9 w-9 inline-flex items-center justify-center rounded-md text-gray-600 hover:text-black hover:bg-gray-100"
          type="button"
          aria-label="Close"
        >
          ✕
        </button>
        {title && <h3 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 pr-10 break-words">{title}</h3>}
        <div className="overflow-y-auto overflow-x-auto max-h-[min(70vh,calc(100vh-8rem))] -mx-1 px-1">
          {items.length > 0 ? (
            <table className="w-full mb-4 text-sm min-w-[320px]">
              <thead>
                <tr>
                  <th className="text-left">Product</th>
                  <th className="text-left">Price</th>
                  <th className="text-left">Qty</th>
                  <th className="text-left">Amount</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, idx) => (
                  <tr key={item.id || item.item_id || idx}>
                    <td>{item.product || item.name}</td>
                    <td>{item.price || item.rate}</td>
                    <td>
                      <input
                        type="number"
                        min="1"
                        className="border rounded px-2 py-1 w-16"
                        value={quantities[idx]}
                        onChange={e => handleQtyChange(idx, e.target.value)}
                      />
                    </td>
                    <td>
                      {((item.price || item.rate) * quantities[idx]).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            children
          )}
        </div>

        {/* Footer Buttons */}
        {/* <div className="flex justify-end gap-2 mt-4">
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            onClick={handleReorder}
            disabled={creating}
          >
            {creating ? 'Reordering...' : 'Reorder'}
          </button>
          <button
            className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
            onClick={onClose}
          >
            Cancel
          </button>
        </div> */}
        {createError && <div className="text-red-600 mt-2">{createError}</div>}
      </div>
    </div>
  )
}

export default SalesOrderPopup
